// import React, { useEffect, useState } from "react";
// import { Spinner, Alert, Table, Button, FormControl, Badge, Form, Modal, Breadcrumb } from "react-bootstrap";
// import { 
//   getCountries, createCountry, updateCountry, deleteCountry,
//   getStatesByCountry, createState, updateState, deleteState,
//   getCitiesByState, createCity, updateCity, deleteCity 
// } from "../../../services/apiService"; // Path apne hisab se check karlein

// const LocationManagement = () => {
//   // Navigation States
//   const [view, setView] = useState("countries"); // "countries", "states", "cities"
//   const [selectedCountry, setSelectedCountry] = useState(null);
//   const [selectedState, setSelectedState] = useState(null);

//   // Data States
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");

//   // Modal States
//   const [showModal, setShowModal] = useState(false);
//   const [editItem, setEditItem] = useState(null);
//   const [formData, setFormData] = useState({ name: "", iso2: "", iso3: "", phone_code: "" });

//   // --- FETCHING LOGIC ---

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       setError("");
//       let res;
//       if (view === "countries") {
//         res = await getCountries();
//       } else if (view === "states") {
//         res = await getStatesByCountry(selectedCountry._id);
//       } else if (view === "cities") {
//         res = await getCitiesByState(selectedState._id);
//       }
//       setItems(res.data || []);
//     } catch (err) {
//       setError(err.message || "Failed to fetch data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [view, selectedCountry, selectedState]);

//   // --- HANDLERS ---

//   const handleNavigateToStates = (country) => {
//     setSelectedCountry(country);
//     setView("states");
//   };

//   const handleNavigateToCities = (state) => {
//     setSelectedState(state);
//     setView("cities");
//   };

//   const handleBackToCountries = () => {
//     setSelectedCountry(null);
//     setSelectedState(null);
//     setView("countries");
//   };

//   const handleBackToStates = () => {
//     setSelectedState(null);
//     setView("states");
//   };

//   // --- CRUD OPERATIONS ---

//   const handleShowModal = (item = null) => {
//     setEditItem(item);
//     if (item) {
//       setFormData({ name: item.name, iso2: item.iso2 || "", iso3: item.iso3 || "", phone_code: item.phone_code || "" });
//     } else {
//       setFormData({ name: "", iso2: "", iso3: "", phone_code: "" });
//     }
//     setShowModal(true);
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     try {
//       if (view === "countries") {
//         editItem ? await updateCountry(editItem._id, formData) : await createCountry(formData);
//       } else if (view === "states") {
//         const payload = { ...formData, country: selectedCountry._id };
//         editItem ? await updateState(editItem._id, payload) : await createState(payload);
//       } else if (view === "cities") {
//         const payload = { ...formData, state: selectedState._id, country: selectedCountry._id };
//         editItem ? await updateCity(editItem._id, payload) : await createCity(payload);
//       }
//       setShowModal(false);
//       fetchData();
//     } catch (err) {
//       setError(err.message || "Save failed");
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this?")) return;
//     try {
//       if (view === "countries") await deleteCountry(id);
//       else if (view === "states") await deleteState(id);
//       else if (view === "cities") await deleteCity(id);
//       fetchData();
//     } catch (err) {
//       setError(err.message || "Delete failed");
//     }
//   };

//   // Filter items based on search
//   const filteredItems = items.filter(item => 
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   if (loading && items.length === 0) {
//     return <div className="text-center mt-5"><Spinner animation="border" /><p>Loading...</p></div>;
//   }

//   return (
//     <div className="container mt-4">
//       {/* HEADER & BREADCRUMBS */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h2>Manage <Badge bg="primary">{view.toUpperCase()}</Badge></h2>
//         <Button variant="success" onClick={() => handleShowModal()}>+ Add New {view.slice(0, -1)}</Button>
//       </div>

//       <Breadcrumb className="bg-light p-2 rounded shadow-sm">
//         <Breadcrumb.Item onClick={handleBackToCountries} active={view === "countries"}>Countries</Breadcrumb.Item>
//         {selectedCountry && (
//           <Breadcrumb.Item onClick={handleBackToStates} active={view === "states"}>{selectedCountry.name}</Breadcrumb.Item>
//         )}
//         {selectedState && <Breadcrumb.Item active>{selectedState.name}</Breadcrumb.Item>}
//       </Breadcrumb>

//       {/* SEARCH BAR */}
//       <Form className="mb-3">
//         <FormControl
//           type="text"
//           placeholder={`Search ${view}...`}
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </Form>

//       {error && <Alert variant="danger">{error}</Alert>}

//       {/* DATA TABLE */}
//       <Table striped bordered hover responsive className="align-middle text-center shadow-sm">
//         <thead className="table-dark">
//           <tr>
//             <th>#</th>
//             <th>Name</th>
//             {view === "countries" && <th>ISO Codes</th>}
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredItems.map((item, index) => (
//             <tr key={item._id}>
//               <td>{index + 1}</td>
//               <td className="fw-bold text-primary" style={{ cursor: "pointer" }} 
//                   onClick={() => view === "countries" ? handleNavigateToStates(item) : view === "states" ? handleNavigateToCities(item) : null}>
//                 {item.name}
//               </td>
//               {view === "countries" && <td>{item.iso2} / {item.iso3}</td>}
//               <td>
//                 <Button variant="outline-info" size="sm" className="me-2" onClick={() => handleShowModal(item)}>Edit</Button>
//                 <Button variant="outline-danger" size="sm" onClick={() => handleDelete(item._id)}>Delete</Button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>

//       {/* ADD/EDIT MODAL */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Form onSubmit={handleSave}>
//           <Modal.Header closeButton>
//             <Modal.Title>{editItem ? "Edit" : "Add"} {view.slice(0, -1)}</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form.Group className="mb-3">
//               <Form.Label>Name</Form.Label>
//               <Form.Control 
//                 required 
//                 value={formData.name} 
//                 onChange={(e) => setFormData({ ...formData, name: e.target.value })} 
//               />
//             </Form.Group>

//             {view === "countries" && (
//               <div className="row">
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label>ISO2</Form.Label>
//                     <Form.Control maxLength="2" value={formData.iso2} onChange={(e) => setFormData({ ...formData, iso2: e.target.value })} />
//                   </Form.Group>
//                 </div>
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label>ISO3</Form.Label>
//                     <Form.Control maxLength="3" value={formData.iso3} onChange={(e) => setFormData({ ...formData, iso3: e.target.value })} />
//                   </Form.Group>
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
//             <Button variant="primary" type="submit">Save Changes</Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default LocationManagement;


import React, { useEffect, useState } from "react";
import {
  Spinner,
  Alert,
  Table,
  Button,
  FormControl,
  Badge,
  Form,
  Modal,
  Breadcrumb
} from "react-bootstrap";

import {
  getCountries,
  createCountry,
  updateCountry,
  deleteCountry,
  getStatesByCountry,
  createState,
  updateState,
  deleteState,
  getCitiesByState,
  createCity,
  updateCity,
  deleteCity,
  bulkDeleteCities
} from "../../../services/apiService";

const LocationManagement = () => {

  const [view, setView] = useState("countries");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  const [items, setItems] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    iso2: "",
    iso3: "",
    phone_code: ""
  });

  // ================= FETCH DATA =================

  const fetchData = async () => {
    try {
      setLoading(true);
      setError("");

      let res;

      if (view === "countries") {
        res = await getCountries();
      }

      if (view === "states") {
        res = await getStatesByCountry(selectedCountry._id);
      }

      if (view === "cities") {
        res = await getCitiesByState(selectedState._id);
      }

      setItems(res.data || []);
    } catch (err) {
      setError(err.message || "Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [view, selectedCountry, selectedState]);

  // reset checkbox when view changes
  useEffect(() => {
    setSelectedCities([]);
  }, [view]);

  // ================= NAVIGATION =================

  const handleNavigateToStates = (country) => {
    setSelectedCountry(country);
    setView("states");
  };

  const handleNavigateToCities = (state) => {
    setSelectedState(state);
    setView("cities");
  };

  const handleBackToCountries = () => {
    setSelectedCountry(null);
    setSelectedState(null);
    setView("countries");
  };

  const handleBackToStates = () => {
    setSelectedState(null);
    setView("states");
  };

  // ================= CHECKBOX =================

  const handleCitySelect = (id) => {
    setSelectedCities((prev) =>
      prev.includes(id)
        ? prev.filter((cityId) => cityId !== id)
        : [...prev, id]
    );
  };

  const handleSelectAllCities = (checked) => {
    if (checked) {
      setSelectedCities(filteredItems.map((item) => item._id));
    } else {
      setSelectedCities([]);
    }
  };

  // ================= BULK DELETE =================

  const handleBulkDeleteCities = async () => {
    if (selectedCities.length === 0) {
      alert("Select cities first");
      return;
    }

    if (!window.confirm("Delete selected cities?")) return;

    try {
      await bulkDeleteCities(selectedCities);
      setSelectedCities([]);
      fetchData();
    } catch (err) {
      setError(err.message || "Bulk delete failed");
    }
  };

  // ================= CRUD =================

  const handleShowModal = (item = null) => {
    setEditItem(item);

    if (item) {
      setFormData({
        name: item.name,
        iso2: item.iso2 || "",
        iso3: item.iso3 || "",
        phone_code: item.phone_code || ""
      });
    } else {
      setFormData({
        name: "",
        iso2: "",
        iso3: "",
        phone_code: ""
      });
    }

    setShowModal(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {

      if (view === "countries") {
        editItem
          ? await updateCountry(editItem._id, formData)
          : await createCountry(formData);
      }

      if (view === "states") {
        const payload = { ...formData, country: selectedCountry._id };

        editItem
          ? await updateState(editItem._id, payload)
          : await createState(payload);
      }

      if (view === "cities") {
        const payload = {
          ...formData,
          state: selectedState._id,
          country: selectedCountry._id
        };

        editItem
          ? await updateCity(editItem._id, payload)
          : await createCity(payload);
      }

      setShowModal(false);
      fetchData();

    } catch (err) {
      setError(err.message || "Save failed");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;

    try {

      if (view === "countries") await deleteCountry(id);
      if (view === "states") await deleteState(id);
      if (view === "cities") await deleteCity(id);

      fetchData();

    } catch (err) {
      setError(err.message || "Delete failed");
    }
  };

  // ================= FILTER =================

  const filteredItems = items.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ================= LOADING =================

  if (loading && items.length === 0) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
        <p>Loading...</p>
      </div>
    );
  }

  // ================= UI =================

  return (
    <div className="container mt-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-3">

        <h2>
          Manage <Badge bg="primary">{view.toUpperCase()}</Badge>
        </h2>

        <div className="d-flex gap-2">

          <Button variant="success" onClick={() => handleShowModal()}>
            + Add New {view.slice(0, -1)}
          </Button>

          {view === "cities" && (
            <Button
              variant="danger"
              disabled={selectedCities.length === 0}
              onClick={handleBulkDeleteCities}
            >
              Delete Selected
            </Button>
          )}

        </div>
      </div>

      {/* BREADCRUMB */}

      <Breadcrumb className="bg-light p-2 rounded shadow-sm">

        <Breadcrumb.Item
          onClick={handleBackToCountries}
          active={view === "countries"}
        >
          Countries
        </Breadcrumb.Item>

        {selectedCountry && (
          <Breadcrumb.Item
            onClick={handleBackToStates}
            active={view === "states"}
          >
            {selectedCountry.name}
          </Breadcrumb.Item>
        )}

        {selectedState && (
          <Breadcrumb.Item active>
            {selectedState.name}
          </Breadcrumb.Item>
        )}

      </Breadcrumb>

      {/* SEARCH */}

      <Form className="mb-3">
        <FormControl
          type="text"
          placeholder={`Search ${view}...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}

      {/* TABLE */}

      <Table striped bordered hover responsive className="text-center shadow-sm">

        <thead className="table-dark">

          <tr>

            {view === "cities" && (
              <th>
                <Form.Check
                  type="checkbox"
                  checked={
                    selectedCities.length === filteredItems.length &&
                    filteredItems.length > 0
                  }
                  onChange={(e) =>
                    handleSelectAllCities(e.target.checked)
                  }
                />
              </th>
            )}

            <th>#</th>
            <th>Name</th>

            {view === "countries" && <th>ISO</th>}

            <th>Actions</th>

          </tr>

        </thead>

        <tbody>

          {filteredItems.map((item, index) => (

            <tr key={item._id}>

              {view === "cities" && (

                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedCities.includes(item._id)}
                    onChange={() => handleCitySelect(item._id)}
                  />
                </td>

              )}

              <td>{index + 1}</td>

              <td
                className="fw-bold text-primary"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  view === "countries"
                    ? handleNavigateToStates(item)
                    : view === "states"
                    ? handleNavigateToCities(item)
                    : null
                }
              >
                {item.name}
              </td>

              {view === "countries" && (
                <td>
                  {item.iso2} / {item.iso3}
                </td>
              )}

              <td>

                <Button
                  variant="outline-info"
                  size="sm"
                  className="me-2"
                  onClick={() => handleShowModal(item)}
                >
                  Edit
                </Button>

                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleDelete(item._id)}
                >
                  Delete
                </Button>

              </td>

            </tr>

          ))}

        </tbody>

      </Table>

      {/* MODAL */}

      <Modal show={showModal} onHide={() => setShowModal(false)}>

        <Form onSubmit={handleSave}>

          <Modal.Header closeButton>
            <Modal.Title>
              {editItem ? "Edit" : "Add"} {view.slice(0, -1)}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>

            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>

              <Form.Control
                required
                value={formData.name}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    name: e.target.value
                  })
                }
              />

            </Form.Group>

            {view === "countries" && (

              <div className="row">

                <div className="col-md-6">

                  <Form.Group className="mb-3">

                    <Form.Label>ISO2</Form.Label>

                    <Form.Control
                      maxLength="2"
                      value={formData.iso2}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          iso2: e.target.value
                        })
                      }
                    />

                  </Form.Group>

                </div>

                <div className="col-md-6">

                  <Form.Group className="mb-3">

                    <Form.Label>ISO3</Form.Label>

                    <Form.Control
                      maxLength="3"
                      value={formData.iso3}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          iso3: e.target.value
                        })
                      }
                    />

                  </Form.Group>

                </div>

              </div>

            )}

          </Modal.Body>

          <Modal.Footer>

            <Button
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>

            <Button variant="primary" type="submit">
              Save Changes
            </Button>

          </Modal.Footer>

        </Form>

      </Modal>

    </div>
  );
};

export default LocationManagement;